import React from 'react'
import { currentOpenings } from '../Utils/dummy_data'

const Carreer = () => {
  return (
    <div className=''>
      <h2 className='text-5xl py-20 uppercase font-bold text-main'><a href='/carreer'>Work with us</a></h2>
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-16'>
        {currentOpenings.map((item, index) => {

          return <div>
            <img src={item?.coverPhoto} className='object-cover w-full' />
            <div className='py-4 bg-[#f2f2f2] px-5 font-semibold tracking-wider'>
              <p>{item.title}</p>
            </div>

          </div>
        })}
       
        
        
      </div>
      <button className=' my-4 float-right  py-2 bg-main text-[#f2f2f2] px-6 rounded-full'><a href='/carreer'>Learn More</a></button>
    </div>
  )
}

export default Carreer